import { IconClose } from '@components/Icon';
import { Portal, PortalNamespace } from '@components/Portal';
import React, { useEffect } from 'react';
import { CSSProperties } from 'styled-components';

import {
  Body,
  Close,
  CloseBtn,
  Content,
  Dialog,
  Header,
  Heading,
  UiBlock,
  Wrapper,
} from './wrapper';

interface IModal {
  children: React.ReactNode;
  onClose?: (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>) => void;
  portalId?: string;
  title?: string;
  overlay?: boolean;
  styles?: {
    dialog?: CSSProperties;
    content?: CSSProperties;
    body?: CSSProperties;
  };
  showCloseButton?: boolean;
}

const Modal = ({
  portalId,
  title,
  onClose,
  children,
  overlay,
  styles,
  showCloseButton = true,
}: IModal) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose) {
        onClose(e as any);
      }
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <Portal id={portalId || PortalNamespace}>
      <Wrapper $overlay={overlay}>
        {onClose && <UiBlock onClick={onClose} title="Stäng modal" />}
        <Dialog style={styles?.dialog} role="dialog" aria-modal="true">
          <Content style={styles?.content}>
            {title && (
              <Header>
                <Heading>{title}</Heading>
                {onClose && showCloseButton && (
                  <Close>
                    <CloseBtn onClick={onClose} title="Stäng modal">
                      <IconClose />
                    </CloseBtn>
                  </Close>
                )}
              </Header>
            )}
            <Body style={styles?.body}>{children}</Body>
          </Content>
        </Dialog>
      </Wrapper>
    </Portal>
  );
};

export default Modal;
